import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import ActivitiesIndex from './pages/ActivitiesIndex.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/activities'),
    component: ActivitiesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'activities_dashboard_index',
        component: ActivitiesIndex,
        meta: commonMeta,
      },
    ],
  },
];
